import { useNavigate } from "react-router-dom";
import { ReceiptsPage as ReceiptsPageView } from "@/components/ReceiptsPage";

export function ReceiptsPage() {
  const navigate = useNavigate();

  return <ReceiptsPageView onReceiptClick={(receiptId) => navigate(`/receipts/${receiptId}`)} />;
}
